export class TaiwanRequestedInfo {

    nationalID: string = '';
    criminalRecordNumber : string = '';
    promoCode: string = '';

    constructor(jsonObject: any = null) {
        if (jsonObject !== null) {
            if (jsonObject instanceof TaiwanRequestedInfo) {
                this.nationalID = jsonObject.nationalID;
                this.criminalRecordNumber = jsonObject.criminalRecordNumber;
                this.promoCode = jsonObject.promoCode;

            } else {
                // this is a json object let's deserialize it
                if (jsonObject.hasOwnProperty('attributes') && jsonObject.attributes instanceof Array) {
                    jsonObject.attributes.forEach( (property : any) =>{
                        if(property.name === "TAIWAN NATIONAL ID"){
                            this.nationalID = property.value;
                        }
                        if(property.name === "PoliceCertNbr"){
                            this.criminalRecordNumber = property.value;
                        }
                    });
                }
                if(jsonObject.hasOwnProperty('promotionCode')){
                    this.promoCode = jsonObject.promotionCode;
                }
            }
        }
    }
}
